var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useState, useCallback, useContext, useEffect } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { Color } from 'three';
import { useSpring } from '@react-spring/three';
import { PerspectiveCamera } from '@react-three/drei';
import { useTheme } from '../hooks/use-theme';
import { FogCamera } from '../fog';
const WeatherContext = createContext({});
const Container = (props) => {
    const { scene, camera } = useThree();
    useFrame(() => {
        var _a, _b;
        scene.background = new Color((_a = props.style.backgroundColor) === null || _a === void 0 ? void 0 : _a.get());
        if (props.type !== 'fog' && ((_b = props.style.backgroundColor) === null || _b === void 0 ? void 0 : _b.idle)) {
            camera.lookAt(0, 0, 0);
            camera.position.z = 5;
        }
    });
    return React.createElement(React.Fragment, null, props.children);
};
export const WeatherProvider = (_a) => {
    var { defaultMode = 'day', defaultType = 'sun' } = _a, props = __rest(_a, ["defaultMode", "defaultType"]);
    const [type, setType] = useState(defaultType);
    const [mode, setMode] = useState(defaultMode);
    const controlType = props.type || type;
    const controlMode = props.mode || mode;
    const { bind } = useTheme({ type: controlType, mode: controlMode });
    const _b = bind(), { style: _style } = _b, config = __rest(_b, ["style"]);
    const [style, api] = useSpring(() => ({
        backgroundColor: _style.backgroundColor,
    }));
    useEffect(() => {
        api.start({
            backgroundColor: _style.backgroundColor,
        });
    }, [_style.backgroundColor, api]);
    const handleChangeType = useCallback((type) => {
        setType(type);
    }, []);
    const handleChangeMode = useCallback((mode) => {
        setMode(mode);
    }, []);
    return (React.createElement(WeatherContext.Provider, { value: { type: controlType, mode: controlMode, handleChangeType, handleChangeMode } },
        props.extra,
        React.createElement(Canvas, Object.assign({}, config),
            controlType === 'fog' ? (React.createElement(FogCamera, null)) : (React.createElement(PerspectiveCamera, { makeDefault: true, args: [75, 0, 0.1, 1000] })),
            React.createElement(Container, { type: controlType, style: style }, props.children))));
};
export const useWeather = () => useContext(WeatherContext);
export const WeatherConsumer = WeatherContext.Consumer;
